import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor, getFontWeight } from '../../../util/theme';

const BranchTile = styled.div`
  background-color: ${getColor('primaryBlue')};

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  display: flex;
  align-items: center;
  justify-content: center;

  flex-basis: 40%;

  transition: 0.1s all linear;

  @supports not (display: grid) {
    margin: 15px;
  }

  @media (min-width: ${getBreakpoint('lg')}) {
    flex-basis: 20%;
  }

  &:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  }

  a {
    height: 100%;
    width: 100%;

    padding: 25px 0;

    display: flex;
    align-items: center;
    justify-content: space-evenly;

    /* fix for dumb MS Edge not supporting space-evenly properly */
    /* https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/15947692/ */
    @supports (-ms-ime-align: auto) {
      justify-content: space-around;
    }

    &.fuzzy {
      filter: blur(7px);

      &:hover {
        h2 {
          color: ${getColor('white')};
        }

        svg {
          fill: ${getColor('white')};
        }
      }
    }

    &:hover,
    &:focus {
      text-decoration: none;

      h2 {
        color: ${getColor('accentGreen')};
      }

      div {
        svg {
          fill: ${getColor('accentGreen')};
        }
      }
    }
  }

  h2 {
    color: ${getColor('white')};
    font-size: 1.5rem;
    font-weight: ${getFontWeight('bold')};
    letter-spacing: 0.1rem;
    text-align: center;

    @media (min-width: ${getBreakpoint('lg')}) {
      font-size: 1.75rem;
    }
  }
`;

export default BranchTile;
